import PropTypes from 'prop-types';

export default PropTypes.shape({
    isBroken: PropTypes.bool,
    url: PropTypes.string.isRequired,
    link_type: PropTypes.string.isRequired,
    target: PropTypes.string,
});
